import {h} from "vue";
import {RouterView} from "vue-router";

export default [
    {
        path: '/dashboard',
        name: "VDashboard",
        meta: {
            title: "渠道首页",
            icon: 'el-icon-yxy-home',
        },
        component: () => import("@/views/Dashboard/Dashboard")
    },
    {
        path: '/game',
        name: "AppGameList",
        meta: {
            title: "游戏列表",
            icon: 'el-icon-yxy-game',
        },
        component: () => import("@/views/game/appGame/List")
    },
    {
        path: '/agent',
        name: "Agent",
        meta: {
            title: "代充中心",
            icon: 'el-icon-yxy-tixian',
            channelType: 2
        },
        component: {render:() => h(RouterView)},
        children:[
            {
                path: 'promote-discount',
                name: "AgentChildPromoteDiscount",
                meta: {
                    title: "子渠道加点",
                    channelType: 2,
                    level:1
                },
                component: () => import("@/views/Agent/childPromoteDiscount/List"),
            },
            {
                path: 'promote-list',
                name: "AgentChildPromoteList",
                meta: {
                    title: "子渠道列表",
                    channelType: 2,
                    level:1
                },
                component: () => import("@/views/Agent/childPromote/List"),
            },
            {
                path: 'recharge-game',
                name: "AgentRechargeGame",
                meta: {
                    title: "代充充值",
                    channelType: 2,
                },
                component: () => import("@/views/Agent/rechargeGame/Index.vue"),
            },
            {
                path: 'auto-recharge',
                name: "AutoRecharge",
                meta: {
                    title: "自助加币",
                    channelType: 2,
                },
                component: () => import("@/views/Agent/AutoRecharge/Index.vue"),
            }
        ]
    },
    {
        path: '/data/user-white',
        name: "UserWhiteList",
        meta: {
            title: "用户折扣",
            icon: 'el-icon-yxy-zhekou',
        },
        component: () => import("@/views/data/userWhite/List")
    },
    {
        path: '/order',
        name: "Order",
        meta: {
            title: "订单明细",
            icon: 'el-icon-yxy-chongzhijilu',
        },
        component: () => import("@/views/order/gameRecharge/List")
    },
    {
        path: '/data/user',
        name: "DataUserList",
        meta: {
            title: "注册明细",
            icon: 'el-icon-yxy-yonghu1',
        },
        component: () => import("@/views/data/user/List")
    },
    {
        path: '/data/settle',
        name: "Settle",
        meta: {
            title: "结算明细",
            icon: 'el-icon-yxy-jiesuan',
        },
        component: () => import("@/views/order/gameRechargeSettle/List")
    },
    {
        path: '/wallet',
        name: "Wallet",
        meta: {
            title: "我的钱包",
            icon: 'el-icon-yxy-Wallet',
        },
        component: {render:() => h(RouterView)},
        children:[
            {
                path: 'log',
                name: "WalletLog",
                meta: {
                    title: "钱包明细"
                },
                component: () => import("@/views/wallet/walletLog/List"),
            },
            {
                path: 'draw',
                name: "WithdrawApply",
                meta: {
                    title: "立即提现"
                },
                component: () => import("@/views/wallet/withdraw/Apply"),
            },
            {
                path: 'withdraw',
                name: "Withdraw",
                meta: {
                    title: "提现管理"
                },
                component: () => import("@/views/wallet/withdraw/List")
            },
            {
                path: 'agent',
                name: "WithdrawAgent",
                meta: {
                    title: "平台币记录",
                    channelType: 2
                },
                component: () => import("@/views/wallet/agent/List")
            }
        ]
    },
    {
        path: '/user-info',
        name: "UserInfo",
        meta: {
            title: "个人中心",
            icon: 'el-icon-yxy-yonghu3',
        },
        component: () => import("@/views/promote/Info/Index"),
        children:[
            {
                path: '?active=info',
                name: "PromoteInfoBaseInfo",
                meta: {
                    title: "基本信息"
                },
                component: () => import("@/views/promote/Info/Index"),
            },
            {
                path: '?active=settle-account',
                name: "PromoteInfoSettleAccount",
                meta: {
                    title: "结算信息"
                },
                component: () => import("@/views/promote/Info/Index"),
            },
            {
                path: '?active=password',
                name: "PromoteInfoPassword",
                meta: {
                    title: "修改登录密码"
                },
                component: () => import("@/views/promote/Info/Index"),
            },
            {
                path: '?active=second-password',
                name: "PromoteInfoSecondPassword",
                meta: {
                    title: "修改二级密码"
                },
                component: () => import("@/views/promote/Info/Index"),
            }
        ]
    },
    {
        path: "/sham-search",
        name: "ShamSearch",
        meta: {
            title: "钓鱼库",
            icon: "el-icon-yxy-Fishing",
            menu:true,
            level:1
        },
        component: () => import("@/views/ShamSearch")
    },
]
